module.exports = __webpack_public_path__ + "img/Password.4dbdf596.svg";